import { AbstractEntityStore } from './AbstractEntityStore';

import { store } from '@/decorators/store';
import { ProQAScript } from '@/entities/ProQAScript';

@store({ id: 'ProQAScriptStore' })
export class ProQAScriptStore extends AbstractEntityStore<ProQAScript> {
  protected entityIdKey = 'tripId';
}
